import { RouterManager } from '@aclass/admin/managers';
import { OfflineBookingEmailStory } from '@aclass/admin/storage/actions';
import { IAdminState, IOfflineBookingEmailModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class OfflineBookingEmailEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:offline-booking-email-edit';

    private id: string;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IOfflineBookingEmailModuleState['editPageRecordId']>(['offlineBookingEmailModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(OfflineBookingEmailEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        const id = route.params.id;
        this.id = id;
        this.ngRdx.dispatch(OfflineBookingEmailStory.dryRunEditPage(id));
    }
}
